import { Badge, type BadgeProps } from "@chakra-ui/react";
import { INQUIRY_STATUS_CONFIG_MAP } from "@equidefi/shared";

interface InquiryStatusBadgeProps extends BadgeProps {
  status?: string;
}

const NA = {
  color: "gray",
  display: "N/A",
};

export const InquiryStatusBadge = ({ status, ...rest }: InquiryStatusBadgeProps) => {
  const config = INQUIRY_STATUS_CONFIG_MAP?.[status] ?? NA;

  return (
    <Badge
      colorScheme={config?.color}
      variant="solid"
      borderRadius="full"
      px={3}
      py={1}
      fontWeight="semibold"
      {...rest}>
      {config?.display}
    </Badge>
  );
};
